<template>
<m-pageframe
    title="Test Webchat Widget"
>
<v-container>

    <m-test-widget
        :organization_id="$route.params.organization_id"
    />

    <h2>Help</h2>

    <m-settings-organization-help-widget
        :inboxes="cur_inboxes"
    />

</v-container>
</m-pageframe>
</template>

<script>
export default 
{
    data() {
        return {
        }
    },

    mounted () {
    },

    methods: {

        
    },

    computed: {
       
    },
}
</script>

<style lang="scss" scoped>

</style>